<template>
  <!-- About -->
  <section id="about">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Acerca de mí</h2>
          <h3 class="section-subheading text-muted">Breve recorrido de experiencias.</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <ul class="timeline">
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="./../../assets/img/about/1.jpg" alt>
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>2003-2009</h4>
                  <h4 class="subheading">Comenzando de a poco</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Comencé manteniendo y migrando el sistema Biblitecarios de la UTN - FRBB (Universidad Tecnológica Nacional),
                    Aquí trabajamos con bases de datos no relacionales y creando el nuevo sistema de Gestión Bibliotecaria, permitiendo
                    a la Universidad adelantarse un paso en la Acreditación de carreras (proceso de certificación de universidades).
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="./../../assets/img/about/2.png" alt>
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>2009-2010</h4>
                  <h4 class="subheading">GyC IT Consulting</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Aquí las tareas fueron un mix de Desarrollador (VB6, PHP y ASP.Net) y soporte al usuario, permitiéndome
                    conocer más de cerca las inquitudes del usuario y poder ayudarle a mejorar sus tareas diarias, brindándole soluciones.
                    Además, tuve la posibilidad de trabajar con motores de bases de datos, tales como MS SQL y MySQL!
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="./../../assets/img/about/3.jpg" alt>
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>2010-2011</h4>
                  <h4 class="subheading">Prominente - Grupo Roggio</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    En esta experiencia, tuve la posibilidad de trabajar con múltiples proyectos y clientes, adaptándome rápidamente
                    a los distintos lenguajes que presentaba la empresa; además de conocer maravillosas personas y excelentes profesionales.
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="./../../assets/img/about/4.png" alt>
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>2011-2015</h4>
                  <h4 class="subheading">Banco Roela S.A.</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Gracias a esta oportunidad, no sólo pude conocer sobre las normativas de la Banca Argentina, sino también adentrarme
                    un poco más en las definiciones técnicas, ya que comenzamos con el equipo a tomar definiciones sobre la arquitectura a adoptar para los
                    nuevos proyectos y poder cumplimentar con los requisitos presentados por el cliente.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div class="timeline-image">
                <img class="rounded-circle img-fluid" src="./../../assets/img/about/5.png" alt>
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4>2015-2018</h4>
                  <h4 class="subheading">Tips Salud - Grupo Hospital Privado.</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Aquí tuve la posibilidad de trabajar sobre la visión de un producto único de gestión hospitalaria.
                    Además, comencé a acercarme más a las tareas de gestión y participar en la definición de procesos de las áreas.
                    También fuí parte de la transformación tecnológica del producto, logrando llevarlo de una aplicación de escritorio a Web.
                  </p>
                </div>
              </div>
            </li>
            <li class="timeline-inverted">
              <div class="timeline-image">
                <router-link to="/linkedin" style="color:white;text-decoration:none;">
                  <h4>Conocer
                    <br>más de mí!
                  </h4>
                  <br>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "about-component"
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/AboutComponent/aboutComponent.vue